import { useMutation } from '@tanstack/react-query';
import { viewAsUserPromise, type ViewAsUserParams } from 'src/utils/api';
import { useNotification } from 'src/hooks/use-notification';

export const useViewAsUser = () => {
  const { mutateAsync, isPending, isError } = useMutation({
    mutationFn: viewAsUserPromise,
  });

  const { enqueueErrorNotification } = useNotification();

  const viewAsUserAsync = async (params: ViewAsUserParams) => {
    try {
      const res = await mutateAsync(params);

      if (!res) {
        enqueueErrorNotification('Error fetching token');
      }

      return res;
    } catch (e) {
      console.error('🚀 ~ file: use-view-as-user.ts:37 ~ viewAsUserAsync ~ e:', e);

      enqueueErrorNotification('Error fetching token');
      return null;
    }
  };

  return {
    viewAsUserAsync,
    isLoading: isPending,
    isError,
  };
};
